// « Pourquoi Helicat » : déplace l'emphase d'une carte à l'autre selon la progression du
// défilement dans la section épinglée. Actif uniquement là où le panneau est réellement épinglé
// (au-delà du breakpoint desktop) : en mobile la section est une simple pile, sans JavaScript.
const INDEX_PAD = 2
// on borne la progression juste sous 1 pour que le dernier palier reste atteignable
const PROGRESS_MAX = 0.999
// milieu d'un palier : le clic y vise, à distance de ses deux bornes
const STEP_MIDPOINT = 0.5

const setActive = (root, index) => {
  if (root.dataset.whyActive === String(index)) {
    return
  }
  root.dataset.whyActive = String(index)

  for (const card of root.querySelectorAll('[data-why-card]')) {
    card.classList.toggle('is-active', Number(card.dataset.whyCard) === index)
  }

  const output = root.querySelector('[data-why-current]')
  if (output) {
    output.textContent = String(index + 1).padStart(INDEX_PAD, '0')
  }
}

// course d'épinglage restante ; 0 hors épinglage (mobile), où la section ne dépasse pas le panneau
const travelOf = (root) => {
  const panel = root.querySelector('.why-cards-panel')

  return panel ? root.offsetHeight - panel.offsetHeight : 0
}

const sync = (root) => {
  const cards = root.querySelectorAll('[data-why-card]')
  if (!cards.length) {
    return
  }

  // hors épinglage (mobile), la section ne dépasse pas la hauteur du panneau : on ne touche à rien
  const travel = travelOf(root)
  if (travel <= 0) {
    return
  }

  const progress = Math.min(Math.max(-root.getBoundingClientRect().top / travel, 0), PROGRESS_MAX)
  setActive(root, Math.floor(progress * cards.length))
}

// Clic sur une carte : on ramène le défilement au palier correspondant, plutôt que de poser
// l'emphase à la main — la position de défilement reste ainsi la seule source de vérité, sinon
// le prochain événement de défilement écraserait aussitôt le choix. Hors épinglage (mobile), il
// n'y a pas de course : l'emphase est posée directement.
const activate = (root, index) => {
  const cards = root.querySelectorAll('[data-why-card]')
  const travel = travelOf(root)

  if (travel <= 0) {
    setActive(root, index)

    return
  }

  const progress = (index + STEP_MIDPOINT) / cards.length
  window.scrollTo({
    top: root.getBoundingClientRect().top + window.scrollY + progress * travel,
    behavior: 'smooth'
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('[data-why-cards]')
  if (!roots.length) {
    return
  }

  let queued = false
  const onScroll = () => {
    if (queued) {
      return
    }
    queued = true
    requestAnimationFrame(() => {
      queued = false
      for (const root of roots) {
        sync(root)
      }
    })
  }

  window.addEventListener('scroll', onScroll, {
    passive: true
  })
  window.addEventListener('resize', onScroll, {
    passive: true
  })

  for (const root of roots) {
    for (const card of root.querySelectorAll('[data-why-card]')) {
      const index = Number(card.dataset.whyCard)

      card.addEventListener('click', () => {
        activate(root, index)
      })
      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return
        }
        event.preventDefault()
        activate(root, index)
      })
    }
  }

  onScroll()
})
